module.exports = __webpack_public_path__ + "img/dish.a632b8d2.png";